import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';
import { Toaster } from './components/ui/sonner';
import LogRocket from 'logrocket';

// Initialize LogRocket for session recording and debugging (only once)
// Guard against double initialization in React StrictMode
if (!(window as any).__LOGROCKET_INITIALIZED__) {
  LogRocket.init('kjb0z9/btgtr');
  (window as any).__LOGROCKET_INITIALIZED__ = true;

  // Log session URL for debugging (optional - can be removed later)
  setTimeout(() => {
    LogRocket.getSessionURL((sessionURL) => {
      console.log('LogRocket Session:', sessionURL);
    });
  }, 1000);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>,
);
